__webpack_require__.p = "./dynamo/";